export default __webpack_public_path__ + "static/media/img_reference_bg.58bc6519.png";